import React, { useEffect, useState } from 'react'
import { Form, Input, message } from 'antd'
import { useNavigate, useSearchParams } from 'react-router-dom'

import AuthLayout from './authLayout'
import BlueButton from '../../components/shared/BlueButton'
import { resetPassword } from '../../api/auth'

export default function ResetPassword() {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const navigate = useNavigate();

    const onFinish = async (values) => {
        if (await form.validateFields()) {
            setLoading(true)

            const { password } = values;

            try {
                const res = await resetPassword({ password, token });

                if (res.Code === 1) {
                    message.success("Password reset successfull.");
                    navigate("/");
                } else {
                    message.error(res.Data.message);
                }
            } catch (error) {
                message.error("Something went wrong, please try again later");
                setLoading(false)
            }

            setLoading(false)
        }
    }

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };

    useEffect(() => {
        if (!token) {
            navigate("/");
        }
    })

    return (
        <AuthLayout>
            <section>
                <Form form={form} layout='vertical' onFinish={onFinish} onFinishFailed={onFinishFailed}>
                    <Form.Item name="password" label="New Password" rules={[{ required: true }]} >
                        <Input.Password placeholder='Enter new password' className='rounded-none' />
                    </Form.Item>

                    <Form.Item
                        name="confirm"
                        label="Confirm Password"
                        rules={[{
                            required: true,
                            validator: async (rule, value) => {
                                if (value !== form.getFieldValue('password')) {
                                    throw new Error('Passwords do not match');
                                }
                            }
                        }]}
                    >
                        <Input.Password placeholder='Confirm password' className='rounded-none' />
                    </Form.Item>

                    <Form.Item className='flex justify-center'>
                        <BlueButton type="primary" className="rounded-none min-w-[132.5px]" htmlType="submit" disabled={loading}>{
                            loading ? "Loading..." : "Reset Password"}
                        </BlueButton>
                    </Form.Item>
                </Form>
            </section>
        </AuthLayout>
    )
}
